import React from 'react';
import {
  Drawer,Card,
  Table,
  Button,List,
  Space,
  Typography,
  Tag,
  Empty,
  Tooltip,Divider,Select
} from 'antd';

import {
  ExclamationCircleOutlined, FilterOutlined,  
  DeleteOutlined,LoadingOutlined ,
  SearchOutlined,
  CalendarOutlined,
  UserOutlined,
  HomeOutlined,  
} from '@ant-design/icons';

import moment from 'moment';

import dayjs from 'dayjs';

const { Text } = Typography;

const AsignacionHabitacionesDrawer = ({
  drawerAsignacionVisible,
  onClose,
  lineaSeleccionadaAsignacion,
  habitacionesDisponibles,
  habitacionAsignada,
  cargandoAsignacion,
  asignarHabitacion,  cerrarDrawerAsignacion,
  plantasDisponibles,tiposHabitacionDisponibles,cargandoHabitacionesDisponibles,desasignarHabitacion
}) => {
  return (
    <Drawer
        title={
                lineaSeleccionadaAsignacion ? (
                    <Card size="small" style={{ marginBottom: 16, borderColor: '#1890ff' }}>
                        <Space direction="vertical" style={{ width: '100%' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div>
                                    <Text strong>Habitación {lineaSeleccionadaAsignacion.Linea}</Text>
                                    <Tag color="blue" style={{ marginLeft: 8 }}>
                                        {lineaSeleccionadaAsignacion.TipoHab}
                                    </Tag>
                                </div>
                                <div>
                                    <Text type="secondary">Ocupante {lineaSeleccionadaAsignacion.Numocupante}</Text>
                                </div>
                            </div>                      
                            <div>
                                <Text strong>Cliente:</Text> {lineaSeleccionadaAsignacion.Nombre}
                            </div>                      
                            
                            <div>
                                <CalendarOutlined style={{ marginRight: 4 }} />
                                <Text strong>Fechas:</Text> {moment(lineaSeleccionadaAsignacion.Entrada).format('DD/MM/YY')} - {moment(lineaSeleccionadaAsignacion.Salida).format('DD/MM/YY')}
                                <Text type="secondary" style={{ marginLeft: 8 }}>
                                    ({moment(lineaSeleccionadaAsignacion.Salida).diff(moment(lineaSeleccionadaAsignacion.Entrada), 'days')} noches)
                                </Text>
                            </div>
                      
                            {lineaSeleccionadaAsignacion.NumHab ? (
                                <div style={{ 
                                                display: 'flex', 
                                                alignItems: 'center', 
                                                justifyContent: 'space-between',
                                                padding: 8,
                                                backgroundColor: '#f6ffed',
                                                borderRadius: 4,
                                                border: '1px solid #b7eb8f'
                                            }}>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <HomeOutlined style={{ color: '#52c41a', marginRight: 8 }} />
                                        <div>
                                            <Text strong style={{ color: '#52c41a' }}>Habitación asignada:</Text>
                                            <div style={{ fontSize: 18, fontWeight: 'bold', color: '#52c41a' }}>
                                                {lineaSeleccionadaAsignacion.NumHab}
                                            </div>
                                        </div>
                                    </div>
                                    <Button 
                                        danger 
                                        size="small" 
                                        icon={<DeleteOutlined />}
                                        onClick={() => desasignarHabitacion()}
                                        loading={cargandoAsignacion}
                                    >
                                        Quitar
                                    </Button>
                                </div>
                            ) : (
                                <div style={{ 
                                                padding: 8, 
                                                backgroundColor: '#fff7e6', 
                                                borderRadius: 4,
                                                border: '1px solid #ffd591'
                                            }}>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <ExclamationCircleOutlined style={{ color: '#faad14', marginRight: 8 }} />
                                        <div>
                                            <Text strong style={{ color: '#faad14' }}>Sin habitación asignada</Text>
                                            <div style={{ fontSize: 11, color: '#faad14' }}>
                                                Seleccione una habitación de la lista
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </Space>
                    </Card>
                ) : ('') 
            }
            placement="right"
            width={450}
            open={drawerAsignacionVisible}
            onClose={() => cerrarDrawerAsignacion()}
        >
        
            {lineaSeleccionadaAsignacion ? (
                <div>                                    
                    {/* Filtros y controles */}
                    <Divider orientation="left">
                        <FilterOutlined /> Controles Rápidos
                    </Divider>
                  
                    <Space direction="vertical" style={{ width: '100%' }}>
                    
                    
                        <div style={{ display: 'flex', gap: 8 }}>
                            <Select
                                style={{ flex: 1 }}
                                placeholder="Filtrar por planta"
                                onChange={(planta) => filtrarPorPlanta(planta)}
                                allowClear
                            >
                                {plantasDisponibles.map(planta => (
                                    <Select.Option key={planta} value={planta}>
                                        Planta {planta}
                                    </Select.Option>
                                ))}
                            </Select>
                      
                            <Select
                                style={{ flex: 1 }}
                                placeholder="Filtrar por tipo"
                                onChange={(tipo) => filtrarPorTipo(tipo)}
                                allowClear
                            >
                                {tiposHabitacionDisponibles.map(tipo => (
                                    <Select.Option key={tipo} value={tipo}>
                                        {tipo}
                                    </Select.Option>
                                ))}
                            </Select>
                        </div>
                    </Space>                  
                  
                    {/* Habitaciones disponibles */}
                    <Divider orientation="left">
                        <SearchOutlined /> Habitaciones Disponibles
                        <Tag color="blue" style={{ marginLeft: 8 }}>
                            {habitacionesDisponibles.length} disponibles
                        </Tag>
                        {cargandoHabitacionesDisponibles && (
                            <LoadingOutlined style={{ marginLeft: 8 }} />
                        )}
                    </Divider>
                  
                    {habitacionesDisponibles.length > 0 ? (
                        <List
                            grid={{ gutter: 8, column: 4 }}
                            dataSource={habitacionesDisponibles}
                            loading={cargandoHabitacionesDisponibles}
                            renderItem={(habitacion) => (
                                <List.Item>
                                    <Card 
                                        size="small"
                                        hoverable
                                        onClick={() => {
                                            asignarHabitacion(habitacion.NumHab);
                                            // Después de asignar, buscar siguiente línea sin habitación
                                            // setTimeout(() => buscarSiguienteLineaSinHabitacion(), 500);
                                        }}
                                        style={{
                                            textAlign: 'center',
                                            borderColor: '#d9d9d9',
                                            cursor: 'pointer',
                                            transition: 'all 0.3s',
                                            height: 90,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center'
                                        }}
                                        bodyStyle={{ 
                                            padding: '12px 4px',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                            alignItems: 'center'
                                        }}
                                    >
                                        <div style={{ 
                                                fontSize: 22, 
                                                fontWeight: 'bold', 
                                                color: '#1890ff',
                                                lineHeight: 1
                                            }}>
                                            {habitacion.NumHab}
                                        </div>
                                        <div style={{ 
                                            fontSize: 10, 
                                            color: '#666', 
                                            marginTop: 4,
                                            lineHeight: 1.2
                                        }}>
                                            {habitacion.TipoHab || 'Standard'}
                                        </div>
                                        <div style={{ 
                                            fontSize: 9, 
                                            color: '#999',
                                            marginTop: 2
                                        }}>
                                            Planta: {habitacion.Piso}
                                        </div>
                                        <div style={{ 
                                            fontSize: 9, 
                                            color: '#999',
                                            marginTop: 2
                                        }}>
                                            Descripción: {habitacion.Descrip}
                                        </div>                      
                                        <div style={{ 
                                            fontSize: 9, 
                                            color: '#999',
                                            marginTop: 2
                                        }}>
                                            Ocup. anterior : {habitacion.ocupadasAnterior}
                                        </div>                            
                                        {habitacion.capacidad && (
                                            <div style={{ 
                                                fontSize: 9, 
                                                color: '#999',
                                                marginTop: 1
                                            }}>
                                                Max: {habitacion.capacidad} pers.
                                            </div>
                                        )}
                                    </Card>
                                </List.Item>
                            )}
                        />
                    ) : (
                        <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description={
                                <div>
                                    <div>No hay habitaciones disponibles</div>
                                    <Text type="secondary" style={{ fontSize: 12 }}>
                                        Para las fechas seleccionadas
                                    </Text>
                                </div>
                            }
                        />
                    )}
                </div>
            ) : (
                <div style={{ textAlign: 'center', padding: 40 }}>
                    <UserOutlined style={{ fontSize: 48, color: '#d9d9d9', marginBottom: 16 }} />
                    <div>Seleccione una línea de la tabla</div>
                    <Text type="secondary" style={{ marginBottom: 24 }}>
                        Para comenzar a asignar habitaciones
                    </Text>
                    <Button 
                        type="primary" 
                        onClick={() => {
                            // Ir directamente a la primera línea sin asignar
                            irAPrimeraLineaSinHabitacion();
                        }}
                    >
                        <SearchOutlined /> Buscar primera línea sin asignar
                    </Button>
                </div>
            )}
        </Drawer>
    );
};

export default AsignacionHabitacionesDrawer;
